/** 产品主版本（与 README ESOP V3.0 对齐） */
export const APP_VERSION = '3.0.0';

export function formatSidebarVersion(version: string, buildLabel?: string): string {
  const v = version.startsWith('v') ? version : `v${version}`;
  return buildLabel ? `${v} · ${buildLabel}` : v;
}
